import printables_data from '../data/printables.json'

export function get_printables() {
    const data = printables_data.items
    const status = 200
    return { status, data }
}

export async function get_printable_by_id(id) {
    const data = printables_data.items.find(x => x.id === id);
    var status = data === 'undefined' ? 404 : 200
    return { status, data }
}

